import React, { Component } from 'react'
import Paginator from './component'

import { connect } from 'react-redux'

import { fetchPeerInsights, setCurrentScreen, updatePage, setActiveBusiness, toggleMarketShare } from '../../../redux/peer-insights'

import { fetchSummary } from '../../../redux/summary'

import CenteredSpinner from '../../Atoms/Spinner/CenteredSpinner'
import InlineError from '../../Atoms/InlineError'

class PeerInsightsContainer extends Component {
  componentDidMount () {
    if (!this.props.data[this.props.selectedRound]) {
      this.props.fetchPeerInsights(this.props.teamNumber, this.props.selectedRound)
    }
    if (!this.props.summaries[this.props.selectedRound]) {
      this.props.fetchSummary(this.props.teamNumber, this.props.selectedRound)
    }
  }

  componentDidUpdate (prevProps) {
    if (
      prevProps.selectedRound !== this.props.selectedRound ||
      prevProps.roundNumber !== this.props.roundNumber ||
      prevProps.teamNumber !== this.props.teamNumber ||
      (!prevProps.isCurrentTab && this.props.isCurrentTab)
    ) {
      if (!this.props.data[this.props.selectedRound]) {
        this.props.fetchPeerInsights(this.props.teamNumber, this.props.selectedRound)
      }
      if (!this.props.summaries[this.props.selectedRound]) {
        this.props.fetchSummary(this.props.teamNumber, this.props.selectedRound)
      }
    }
  }

  shouldComponentUpdate (nextProps) {
    if (!nextProps.isCurrentTab) {
      return false
    }
    return true
  }

  render () {
    if (this.props.error) {
      return <InlineError message={this.props.error.message} />
    }
    if (!this.props.isLoading) {
      if (!this.props.data[this.props.selectedRound]) {
        return <InlineError message={`No peer insights have been uploaded for round ${this.props.selectedRound}`} />
      }
      const data = this.props.data[this.props.selectedRound].data.filter(d => d.enabled)
      return (
        <Paginator
          data={data}
          marketShare={this.props.data[this.props.selectedRound].marketShare}
          summaries={this.props.summaries[this.props.selectedRound]}
          selectedRound={this.props.selectedRound}
          currentTeam={this.props.teamNumber}
          currentScreen={this.props.currentScreen}
          setCurrentScreen={this.props.setCurrentScreen}
          currentPage={this.props.currentPage}
          updatePage={this.props.updatePage}
          setActiveBusiness={this.props.setActiveBusiness}
          activeBusiness={this.props.activeBusiness}
          toggleMarketShare={this.props.toggleMarketShare}
          marketShareActive={this.props.marketShareActive}
        />
      )
    }
    return <CenteredSpinner />
  }
}

const mapStateToProps = (state) => ({
  isCurrentTab: state.ui.currentTab === 'PeerInsights',
  teamNumber: state.team.id,
  selectedRound: state.game.selectedRound,
  isLoading: state.peerInsights.isLoading || state.summary.isLoading,
  isLoaded: state.peerInsights.isLoaded && state.summary.isLoaded,
  currentPage: state.peerInsights.currentPage,
  currentScreen: state.peerInsights.currentScreen,
  activeBusiness: state.peerInsights.activeBusiness,
  marketShareActive: state.peerInsights.marketShare,
  error: state.peerInsights.error || state.summary.error,
  data: state.peerInsights.data,
  summaries: state.summary.summaries
})

const mapDispatchToProps = dispatch => ({
  setCurrentScreen (screenIndex, page) {
    return () => {
      dispatch(setCurrentScreen(screenIndex, page))
    }
  },
  fetchPeerInsights (team, round) {
    dispatch(fetchPeerInsights(team, round))
  },
  fetchSummary (team, round) {
    dispatch(fetchSummary(team, round))
  },
  updatePage (page) {
    dispatch(updatePage(page))
  },
  setActiveBusiness (business) {
    return () => {
      dispatch(setActiveBusiness(business))
    }
  },
  toggleMarketShare () {
    return () => {
      dispatch(toggleMarketShare())
    }
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(PeerInsightsContainer)
